<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ 'paymentRequests.title' | translate }}</h4>
    <div class="clear-float-left"></div>
    <br>
    <button [disabled]="!sectionPermission.CanAdd" class="btn btn-raised btn-primary float-right" (click)="openModal()">
      <i
        class="ft-plus-circle"></i> {{ hasDesktopView ? ('paymentRequests.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
    </button>

    <app-company-selection-list [ngClass]="companySelectionListClass" [active]="hasSelectCompanyPermission"
                                [hideLabel]="true" [selectCompanyText]="'users.selectCompanyPlaceHolder' | translate"
                                (companyChangedEvent)="handleCompanyChanged($event)">
    </app-company-selection-list>

    <app-payment-request-status-selection-list class="d-none d-sm-block payment-request-status" [hideLabel]="true"
                                               [selectStatusText]="'paymentRequests.selectStatusPlaceHolder' | translate"
                                               (paymentRequestStatusChangedEvent)="handlePaymentRequestStatusChanged($event)">
    </app-payment-request-status-selection-list>

    <input type='text' class="d-none d-xl-block form-control filter-input"
           placeholder="{{'paymentRequests.filterByDescriptionPlaceHolder' | translate}}"
           (keyup)='searchFilter($event)'/>

    <app-boolean-toggle-filter class="d-none d-xl-block filter-input" [active]="hasToggleUpgradeCreditPermission"
                               [booleanToggleFilterText]="'paymentRequests.showUpgradeCreditText' | translate"
                               (booleanToggleFilterChangedEvent)="handleBooleanToggleFilterChanged($event)">
    </app-boolean-toggle-filter>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ hasDesktopView ? ('paymentRequests.statusFieldTitle' | translate) : '' }}
            <a *ngIf="!paymentRequestFilter.IsUpgradeCreditRequest" class="success"
               title="{{'paymentRequests.statusFieldHint' | translate}}" (click)="updateStatuses()">
              <i class="ft-refresh-cw font-medium-3 ml-1"></i>
            </a>
          </th>
          <th>{{ 'paymentRequests.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let paymentRequest of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <ng-template [ngIf]="paymentRequest.IsExpired">
            <td class="d-none d-sm-table-cell"><i class="circle bg-red"></i></td>
          </ng-template>
          <ng-template [ngIf]="!paymentRequest.IsExpired">
            <td class="d-none d-sm-table-cell"><i class="circle bg-green"></i></td>
          </ng-template>
          <td class="d-none d-lg-table-cell">{{ paymentRequest.PaymentRequestId }}</td>
          <td class="d-none d-sm-table-cell">{{ paymentRequest.CreatedAt | date:'d-M-y HH:mm:ss' }}</td>
          <td>{{ paymentRequest.RemittanceInformation }}</td>
          <td>{{ paymentRequest.AmountCurrency }}</td>
          <td>{{ paymentRequest.ExpirationDate | date:'d-M-y HH:mm' }}</td>
          <td class="d-none d-lg-table-cell">{{ paymentRequest.CompletedAt | date:'d-M-y HH:mm:ss' }}</td>
          <td class="d-none d-xl-table-cell">{{ paymentRequest.CompanyName || "-" }}</td>
          <td><i [ngClass]="paymentRequest.Status.IconClass" title="{{paymentRequest.Status.Hint}}"></i></td>
          <td>
            <!-- TODO: custom right -->
            <a *ngIf="sectionPermission.CanView" class="succes" data-original-title=""
               title="{{'paymentRequests.paymentRequestInformationTitle' | translate: paymentRequest}}"
               (click)="openCustomModalById('PaymentRequestInformationComponent', paymentRequest.PaymentRequestId)">
              <i class="ft-info font-medium-3"></i>
            </a>
            <!-- TODO: only viewable if status is xxx -->
            <a class="info" title="{{'paymentRequests.viewPaymentRequestUrlTitle' | translate}}"
               (click)="openCustomModal('PaymentRequestUrlComponent', paymentRequest, 'modal-backdrop-blur')">
              <i class="ft-link-2 font-medium-3 ml-1"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
